// extracted by mini-css-extract-plugin
export default {"wrapper":"SubCard_wrapper__ir9N7","header":"SubCard_header__C0T4i","title":"SubCard_title__SpZwa"};